import { render, staticRenderFns } from "./EditLog.vue?vue&type=template&id=27cf4d16&scoped=true"
import script from "./EditLog.vue?vue&type=script&lang=js"
export * from "./EditLog.vue?vue&type=script&lang=js"
import style0 from "./EditLog.vue?vue&type=style&index=0&id=27cf4d16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cf4d16",
  null
  
)

export default component.exports